import { ref, shallowRef } from 'vue';
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';

const analytics = shallowRef(null);
const isInitialized = ref(false);
const isIdentified = ref(false);

const init = (writeKey) => {
  console.log('[Customer.io] Initializing...');

  analytics.value = new AnalyticsBrowser();
  analytics.value.load({ writeKey }).then(() => {
    isInitialized.value = true;

    console.log('[Customer.io] Initialized');
  })
};

const identify = (userId) => {
  if (!isInitialized.value) {
    console.warn('[Customer.io] Not initialized, skipping identify');

    return;
  }

  analytics.value.identify(userId).then(() => {
    console.log('[Customer.io] Identified user:', userId);

    isIdentified.value = true;
  });
};

const track = (event, properties) => {
  if (!isInitialized.value) {
    console.warn('[Customer.io] Not ready, skipping event:', JSON.stringify({ event, properties }));

    return;
  }

  if (!isIdentified.value) {
    console.warn('[Customer.io] Not identified, skipping event:', JSON.stringify({ event, properties }));

    return;
  }

  analytics.value.track(event, properties).then(() => {
    console.log('[Customer.io] Tracked event:', JSON.stringify({ event, properties }));
  });
};

const trackPageView = (event) => {
  if (!isInitialized.value) {
    console.warn('[Customer.io] Not ready, skipping page view:', JSON.stringify(event));

    return;
  }

  if (!isIdentified.value) {
    console.warn('[Customer.io] Not identified, skipping page view:', JSON.stringify(event));

    return;
  }

  analytics.value.page(event).then(() => {
    console.log('[Customer.io] Tracked page view:', JSON.stringify(event));
  });
};

const reset = () => {
  if (!isInitialized.value) {
    console.warn('[Customer.io] Not initialized, skipping reset');

    return;
  }

  analytics.value.reset().then(() => {
    console.log('[Customer.io] Reset identified user');

    isIdentified.value = false;
  });
};

export const useCustomerIo = () => ({
  isInitialized,
  isIdentified,
  init,
  identify,
  track,
  trackPageView,
  reset,
});
